/**
 * Canvas visual components
 *
 * Pure SVG-based visuals for canvas blocks (players, drawings, etc.)
 */

// Leaf visuals (render themselves)
export { PlayerVisual } from './PlayerVisual'
export { DrawingVisual } from './DrawingVisual'

// Container visuals (render children)
export { FormationVisual } from './FormationVisual'
export { ConceptVisual } from './ConceptVisual'
export { ConceptReferenceVisual } from './ConceptReferenceVisual'
